import { __decorate, __param, __metadata } from 'tslib';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, EventEmitter, Input, Output, Component, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';
import { UiCToggleModule } from '@wlp/ui-c-toggle';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCAddPartnersService = class UiCAddPartnersService {
    constructor(param) {
        this.config = param;
    }
    getConfig() {
        return this.config;
    }
};
UiCAddPartnersService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCAddPartnersService_Factory() { return new UiCAddPartnersService(ɵɵinject(APP_PARAMETER)); }, token: UiCAddPartnersService, providedIn: "root" });
UiCAddPartnersService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __param(0, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [Object])
], UiCAddPartnersService);

let UiCAddPartnersComponent = class UiCAddPartnersComponent {
    constructor(service) {
        this.service = service;
        this.save = new EventEmitter();
        this.eventLegalRepresentative = new EventEmitter();
        this.eventAttorney = new EventEmitter();
        this.eventPartner = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.onRangeChangeValue = new EventEmitter();
        this.legalRepresentative = false;
        this.master = false;
        this.attorney = false;
        this.partner = false;
        this.signature = false;
        this.clickSignature = true;
        this.offLegalRepresentative = false;
        this.offAttorney = false;
        this.offPartner = false;
        this.offMaster = false;
        this.offSignature = false;
        this.environment = !!this.service.getConfig().device
            ? this.service.getConfig().device
            : 'WEB';
    }
    ngOnInit() {
        if (this.readonly === undefined) {
            this.readonly = false;
        }
        this.formChange();
    }
    formChange() {
        if (!this.formAddPartners) {
            return;
        }
        this.formAddPartners.get('legalRepresentative').value
            ? (this.legalRepresentative = this.formAddPartners.get('legalRepresentative').value)
            : null;
        this.formAddPartners.get('attorney').value ? (this.attorney = this.formAddPartners.get('attorney').value) : null;
        this.formAddPartners.get('partner').value ? (this.partner = this.formAddPartners.get('partner').value) : null;
        this.formAddPartners.get('master').value ? (this.master = this.formAddPartners.get('master').value) : null;
        this.formAddPartners.get('signature').value ? (this.signature = this.formAddPartners.get('signature').value) : null;
    }
    ngOnDestroy() {
        this.offLegalRepresentative = null;
        this.offAttorney = null;
        this.offPartner = null;
        this.master = null;
        this.signature = null;
    }
    checkEmail(event) {
        event.target.value = event.target.value.toUpperCase();
    }
    onRangeChange(event) {
        this.onRangeChangeValue.emit(event);
    }
    saveBtn() {
        this.save.emit();
    }
    formIsValid() {
        if (!this.formAddPartners) {
            return;
        }
        if (this.formAddPartners.invalid) {
            return true;
        }
        else {
            if (this.legalRepresentative === true ||
                this.attorney === true ||
                this.partner === true ||
                this.master === true ||
                this.signature === true) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    ionChangeMaster() {
        this.master = !this.master;
        this.formAddPartners.get('master').setValue(this.master);
        if (this.signature === false) {
            this.clickSignature = false;
            this.signature = !this.signature;
            this.formAddPartners.get('signature').setValue(this.signature);
            this.clickSignature = true;
        }
    }
    ionChangeSignature() {
        if (this.clickSignature) {
            this.signature = !this.signature;
            this.formAddPartners.get('signature').setValue(this.signature);
        }
    }
    ionChangeLegalRepresentative() {
        this.legalRepresentative = !this.legalRepresentative;
        this.formAddPartners.get('legalRepresentative').setValue(this.legalRepresentative);
    }
    ionChangeAttorney() {
        this.attorney = !this.attorney;
        this.formAddPartners.get('attorney').setValue(this.attorney);
    }
    ionChangePartner() {
        this.partner = !this.partner;
        this.formAddPartners.get('partner').setValue(this.partner);
        if (this.partner) {
            this.formAddPartners.get('partnerPercentage').setValue(1);
        }
    }
    cancelEdit() {
        this.onCancel.emit();
    }
    isMobile() {
        return this.environment === 'APP' ? true : false;
    }
};
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCAddPartnersComponent.prototype, "formAddPartners", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "businessPartner", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAddPartnersComponent.prototype, "readonly", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAddPartnersComponent.prototype, "disabledCancel", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "save", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "eventLegalRepresentative", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "eventAttorney", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "eventPartner", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "onCancel", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAddPartnersComponent.prototype, "onRangeChangeValue", void 0);
UiCAddPartnersComponent = __decorate([
    Component({
        selector: 'ui-c-add-partners',
        template: "<div class=\"warning border ion-padding ion-margin mx-0 mt-0\">\n  <ion-row class=\"px-0\">\n    <ion-col class=\"px-0\" size=\"12\">\n      <ng-container *ngIf=\"formAddPartners\">\n        <div class=\"details d-flex justify-content-between align-itens-center flex-wrap\">\n          <!-- nome -->\n          <ion-row class=\"col-12 d-flex ion-justify-content-center\">\n            <ion-col [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\">\n              <div class=\"detail-item\">\n                <div>\n                  <ui-c-input data-cy=\"onboarding-pj-addpartner-fullname\" [form]=\"formAddPartners\"\n                    [errorMessages]=\"errorMessages\" [formName]=\"'fullname'\" [maxlength]=\"40\"\n                    [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.FULL_NAME' | wlpTranslate\"\n                    [name]=\"'ONBORDING.V2.FORM.LABEL.FULL_NAME' | wlpTranslate\">\n                  </ui-c-input>\n                </div>\n              </div>\n            </ion-col>\n\n            <!-- cpf -->\n            <ion-col [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\">\n              <div class=\"detail-item\">\n                <div>\n                  <ui-c-input data-cy=\"onboarding-pj-addpartner-docnumber\" [errorMessages]=\"errorMessages\"\n                    [form]=\"formAddPartners\" [isCPF]=\"true\" [formName]=\"'docNumber'\"\n                    [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.CPF' | wlpTranslate\"\n                    [name]=\"'ONBORDING.V2.FORM.LABEL.CPF' | wlpTranslate\">\n                  </ui-c-input>\n                </div>\n              </div>\n            </ion-col>\n          </ion-row>\n\n          <!-- email -->\n          <ion-row class=\"col-12 d-flex ion-justify-content-center\">\n            <ion-col [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\">\n              <div class=\"detail-item\">\n                <div>\n                  <ui-c-input data-cy=\"onboarding-pj-addpartner-email\" [errorMessages]=\"errorMessages\"\n                    [form]=\"formAddPartners\" [formName]=\"'email'\"\n                    [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.EMAIL' | wlpTranslate\"\n                    [name]=\"'ONBORDING.V2.FORM.LABEL.EMAIL' | wlpTranslate\">\n                  </ui-c-input>\n                </div>\n              </div>\n            </ion-col>\n\n            <!-- celular -->\n            <ion-col [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\">\n              <div class=\"detail-item\">\n                <div>\n                  <ui-c-input data-cy=\"onboarding-pj-addpartner-phone\" [errorMessages]=\"errorMessages\"\n                    [form]=\"formAddPartners\" [formName]=\"'phone'\" [maxlength]=\"15\" [isPhone]=\"true\"\n                    [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.PHONE' | wlpTranslate\"\n                    [name]=\"'ONBORDING.V2.FORM.LABEL.PHONE' | wlpTranslate\">\n                  </ui-c-input>\n                </div>\n              </div>\n            </ion-col>\n          </ion-row>\n        </div>\n        <div [ngClass]=\"{'formMobile': isMobile()}\" [formGroup]=\"formAddPartners\" class=\"mt-3\">\n          <div class=\"px-3\" [ngClass]=\"!formAddPartners?.valid ? 'disabledClick' : ''\">\n            <div\n              class=\"ion-padding px-0 col-12 partner-type-container d-flex justify-content-center align-items-center flex-wrap ion-margin-top\">\n\n              <ion-row id=\"partner-options\" class=\"px-0 d-flex justify-content-flex-start align-items-center w-100\">\n                <ion-col [size]=\"8\" [sizeSm]=\"5\" [sizeMd]=\"2\" class=\"ion-no-padding\">\n                  <ion-item lines=\"none\">\n                    <ion-label>\n                      <ion-text class=\" ion-text-wrap\">\n                        {{ 'ONBORDING.V2.FORM.LABEL.MASTER' | wlpTranslate }}\n                      </ion-text>\n                    </ion-label>\n                    <ion-checkbox data-cy=\"onboarding-pj-addpartner-master\" slot=\"start\" color=\"success\"\n                      formControlName=\"master\" (ionChange)=\"ionChangeMaster()\" [disabled]=\"offMaster\"\n                      style=\"margin-right: 3px;\"></ion-checkbox>\n                  </ion-item>\n                </ion-col>\n                <ion-col [size]=\"8\" [sizeSm]=\"5\" [sizeMd]=\"2\" class=\"ion-no-padding\">\n                  <ion-item lines=\"none\">\n                    <ion-label>\n                      <ion-text class=\" ion-text-wrap\">\n                        {{ 'ONBORDING.V2.FORM.LABEL.SIGNATURE' | wlpTranslate }}\n                      </ion-text>\n                    </ion-label>\n                    <ion-checkbox data-cy=\"onboarding-pj-addpartner-signature\" slot=\"start\" color=\"success\"\n                      formControlName=\"signature\" (ionChange)=\"ionChangeSignature()\" [disabled]=\"offSignature\"\n                      style=\"margin-right: 3px;\">\n                    </ion-checkbox>\n                  </ion-item>\n                </ion-col>\n                <ion-col [size]=\"8\" [sizeSm]=\"5\" [sizeMd]=\"3\" class=\"ion-no-padding\">\n                  <ion-item lines=\"none\">\n                    <ion-label>\n                      <ion-text class=\" ion-text-wrap\">\n                        {{ 'ONBORDING.V2.FORM.LABEL.LEGAL_REPRESENTATIVE' | wlpTranslate }}\n                      </ion-text>\n                    </ion-label>\n                    <ion-checkbox data-cy=\"onboarding-pj-addpartner-legalrepresentative\" slot=\"start\" color=\"success\"\n                      formControlName=\"legalRepresentative\" (ionChange)=\"ionChangeLegalRepresentative()\"\n                      [disabled]=\"offLegalRepresentative\" style=\"margin-right: 3px;\"></ion-checkbox>\n                  </ion-item>\n                </ion-col>\n                <ion-col [size]=\"8\" [sizeSm]=\"5\" [sizeMd]=\"3\" class=\"ion-no-padding\">\n                  <ion-item lines=\"none\">\n                    <ion-label>\n                      <ion-text class=\" ion-text-wrap\">\n                        {{ 'ONBORDING.V2.FORM.LABEL.ATTORNEY' | wlpTranslate }}\n                      </ion-text>\n                    </ion-label>\n                    <ion-checkbox data-cy=\"onboarding-pj-addpartner-attorney\" slot=\"start\" color=\"success\"\n                      formControlName=\"attorney\" (ionChange)=\"ionChangeAttorney()\" [disabled]=\"offAttorney\"\n                      style=\"margin-right: 3px;\">\n                    </ion-checkbox>\n                  </ion-item>\n                </ion-col>\n                <ion-col [size]=\"8\" [sizeSm]=\"5\" [sizeMd]=\"2\" class=\"ion-no-padding\">\n                  <ion-item lines=\"none\">\n                    <ion-label>\n                      <ion-text class=\" ion-text-wrap\">\n                        {{ 'ONBORDING.V2.FORM.LABEL.PARTNER' | wlpTranslate }}\n                      </ion-text>\n                    </ion-label>\n                    <ion-checkbox data-cy=\"onboarding-pj-addpartner-partner\" slot=\"start\" color=\"success\"\n                      (ionChange)=\"ionChangePartner()\" formControlName=\"partner\" style=\"margin-right: 3px;\">\n                    </ion-checkbox>\n                  </ion-item>\n                </ion-col>\n              </ion-row>\n\n            </div>\n          </div>\n          <div class=\"mx-auto col-10  col-md-5 px-0 mt-3\">\n            <ui-c-button data-cy=\"onboarding-pj-savepartner-btn\" expand=\"block\" [disabled]=\"formIsValid()\"\n              (continue)=\"saveBtn()\">\n              <span class=\"title\">{{ 'ONBORDING.V2.BUTTON.SAVE' | wlpTranslate }}</span>\n            </ui-c-button> <br>\n            <div>\n              <ui-c-button\n                *ngIf=\"formAddPartners?.get('master')?.value === false || formAddPartners?.get('master')?.value === undefined\"\n                class=\"btn-cancel\" fill=\"clear\" expand=\"block\" class=\"mt-1\" (continue)=\"cancelEdit()\">\n                <span class=\"title\">{{ 'ONBORDING.V2.BUTTON.CANCEL' | wlpTranslate }}</span>\n              </ui-c-button>\n            </div>\n          </div>\n        </div>\n      </ng-container>\n    </ion-col>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UiCAddPartnersService])
], UiCAddPartnersComponent);

var UiCAddPartnersModule_1;
let UiCAddPartnersModule = UiCAddPartnersModule_1 = class UiCAddPartnersModule {
    constructor(selfModule) { }
    static forRoot(config) {
        return {
            ngModule: UiCAddPartnersModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiCAddPartnersModule = UiCAddPartnersModule_1 = __decorate([
    NgModule({
        declarations: [
            UiCAddPartnersComponent
        ],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            IonicModule,
            NgxMaskIonicModule,
            UiCToggleModule,
            UiCButtonModule,
            UiBsTranslateModule,
            UiCInputModule
        ],
        exports: [
            UiCAddPartnersComponent
        ],
        providers: [
            UiCAddPartnersService
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiCAddPartnersModule])
], UiCAddPartnersModule);

export { UiCAddPartnersComponent, UiCAddPartnersModule, UiCAddPartnersService as ɵa };
//# sourceMappingURL=wlp-ui-c-add-partners.js.map
